import { render } from "./Disciplines.vue?vue&type=template&id=1d26536d&scoped=true&ts=true"
import script from "./Disciplines.ts?vue&type=script&lang=ts&external"
export * from "./Disciplines.ts?vue&type=script&lang=ts&external"

import "./Disciplines.scss?vue&type=style&index=0&id=1d26536d&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d26536d"]])

export default __exports__